export default {"src":"/_next/static/media/sportz-interactive.c1baa248.svg","height":174,"width":134,"blurWidth":0,"blurHeight":0};